import clsx from "clsx";
import Button from "../Button/Button";
import ButtonWithDropdown, {
  IButtonWithDropdown,
} from "../ButtonWithDropdown/ButtonWithDropdown";
import React, { memo } from "react";
import { IButton } from "../Button/Button.types";

interface IButtonGroup {
  buttons?: Array<IButton | IButtonWithDropdown>;
  layout?: "vertical" | "horizontal";
  align?: "center" | "left" | "right";
  gap?: number;
  fullWidth?: boolean;
}

const hasOptions = (
  button: IButton | IButtonWithDropdown,
): button is IButtonWithDropdown => {
  return Array.isArray((button as IButtonWithDropdown)?.options);
};

const ButtonGroup: React.FC<IButtonGroup> = ({
  buttons,
  layout = "horizontal",
  align = "right",
  gap = 4,
  fullWidth = false,
}) => {
  if (!buttons?.length) return null;

  return (
    <div
      className={clsx([
        "flex",
        `gap-${1}`,
        "flex-shrink-0",
        {
          "justify-center": align === "center",
          "justify-start": align === "left",
          "justify-end": align === "right",
          "w-full": fullWidth,
          "flex-row": layout === "horizontal",
          "flex-col": layout === "vertical",
        },
      ])}
      onClick={(e: any) => {
        e?.stopPropagation?.();
      }}
    >
      {buttons.map((button: IButton | IButtonWithDropdown, index: number) =>
        hasOptions(button) ? (
          <ButtonWithDropdown {...button} key={index} />
        ) : (
          <Button {...button} key={index} />
        ),
      )}
    </div>
  );
};

export default memo(ButtonGroup);
